import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {BS2} from "../BS2";
import {BS2GameMode} from "../server/BS2GameMode";
import {gsap} from "gsap";
import {BS2Sound} from "../config/sound/BS2Sound";
import {BS2Statics} from "../config/BS2Statics";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreesSpinOutro implements SimplePresentation {

    name:string = "FreesSpinOutro";

    constructor() {

    }

    public shouldRun():boolean {

        return  BS2.model.isSuperFreespin() && BS2.model.isNextNormal() && !BS2.model.gameData.brokeTheBank && BS2.model.gameData.featureName!==BS2Statics.BOOSTED_BET_2;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();

        tl.add(()=>{
           controller.setSkipCallback(()=> {
               tl.seek("ending", false);
           });
        });
        tl.add(()=>{
            BS2.keypadPlugin.hide();
            BS2.keypadPlugin.setZeroBetSpinCounter(-1);
            BS2.soundPlayer.fadeOutMusic(50);
        });


        tl.add(BS2.transitionScreen.showOutro(BS2.model.gameData.accumulatedRoundWin,BS2.model.gameData.numberOfFreespinsPlayed));
        if(BS2.isWinBelowStakeNoRestriction()) {
            tl.add([
                () => {BS2.soundPlayer.playSound(BS2Sound.SFS_END_MUSIC_BAD);},
                () => {BS2.soundPlayer.playSfsOutroLoop()}
            ], "<");
        }
        else {
            tl.add([
                () => BS2.soundPlayer.playSound(BS2Sound.SFS_END_MUSIC_GOOD),
                () => {BS2.soundPlayer.playSfsOutroLoop()}
            ], "<");
        }

        tl.add(()=>BS2.keypadPlugin.setWin(BS2.model.gameData.accumulatedRoundWin, true, BS2.isWinBelowStake()));

        tl.addLabel("ending");
        tl.add(() => {controller.setSkipCallback();});
        tl.add(BS2.transitionScreen.enableButton(() => this.onButtonClick(controller)));

    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(()=>{
            BS2.soundPlayer.stopSfsOutroLoop();
            BS2.soundPlayer.fadeOutMusic(50);
            BS2.soundPlayer.switchMusic(BS2GameMode.NORMAL);
            BS2.keypadPlugin.show();
            // BS2.reelView.updateReelSize(4);
        });
        tl.add(BS2.transitionScreen.hideOutro());
        tl.add(() => {BS2.soundPlayer.playSound(BS2Sound.SFS_OUTRO_END)}, "<");
        tl.add(() => {
            BS2.soundPlayer.fadeInMusic(150);
        });

        tl.add(() => controller.finish());

    }
}